
export enum CameraVisualizationMode {
    Default,
    Cluster,
    ConnectedComponent,
    Sequence,
}

export default CameraVisualizationMode;
